import { FC } from 'react'
import { UserProtectedRoute } from 'routes'
import CreateReservationFlow from 'components/CommonRoomReservations/CreateReservationFlow'

// Two-step common room reservation creation flow (choose space → choose term).
const CreateReservationPage: FC = () => (
  <UserProtectedRoute>
    <CreateReservationFlow />
  </UserProtectedRoute>
)

export default CreateReservationPage
